const hasUnlimitedDate = dateRanges =>
  Boolean(
    dateRanges.find(
      dateRange => dateRange.includes(null) || dateRange.includes(undefined)
    )
  );

export default hasUnlimitedDate;
